// import * as React from "react";
// import Paper from "@mui/material/Paper";
// import Table from "@mui/material/Table";
// import { useFormik } from "formik";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TablePagination from "@mui/material/TablePagination";
// import TableRow from "@mui/material/TableRow";
// import { useEffect, useState } from "react";
// import {
//   Box,
//   Button,
//   Divider,
//   Modal,
//   Stack,
//   TextField,
//   Typography,
// } from "@mui/material";

// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import SearchIcon from "@mui/icons-material/Search";
// import Swal from "sweetalert2";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import Card from "@mui/material/Card";
// import Grid from "@mui/material/Grid";
// import PrintIcon from "@mui/icons-material/Print";
// import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
// import HOST_URL from "../../../utils/Url";
// import IconButton from "@mui/material/IconButton";
// import CloseIcon from "@mui/icons-material/Close";
// import Autocomplete from "@mui/material/Autocomplete";
// // import TableContainer from '@mui/material/TableContainer';
// import CircularProgress from "@mui/material/CircularProgress";
// import { useTranslation } from "react-i18next";
// import { toast } from "react-toastify";
// import ToastApp from "../../../ToastApp";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import api from "../../../utils/Url";
// import CustomLabel from "../../../CustomLable";
// import { getISTDate } from "../../../utils/Constant";

// const style = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "180vh",
//   height: "92vh",
//   bgcolor: "#f5f5f5",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: 4,
//   borderRadius: 3,
// };

// function createData(
//   srno: number,
//   id: string,
//   roleName: string,
//   userName: string
// ): any {
//   return {
//     srno,
//     id,
//     roleName,
//     userName,
//   };
// }
// function createdData(
//   // srno: number,
//   id: string,
//   menuId: number,
//   parentId: number,
//   menuName: string,
//   parentMenuName: string,
//   isAdd: boolean,
//   isEdit: boolean,
//   isDel: boolean,
//   isView: boolean,
//   isPrint: boolean,
//   isExport: boolean,
//   isRelease: boolean,
//   isPost: boolean,
//   UserId: string
// ): any {
//   return {
//     // srno,
//     id,
//     menuId,
//     parentId,
//     menuName,
//     parentMenuName,
//     isAdd,
//     isEdit,
//     isDel,
//     isView,
//     isPrint,
//     isExport,
//     isRelease,
//     isPost,
//     UserId,
//   };
// }

// function childMenuCreateData(
//   roleId: any,
//   menuId: string,
//   menuName: string,
//   parentId: number,
//   // pageUrl: string,
//   // icon: string,
//   // displayNo: number,
//   //isMenu: boolean,
//   isAdd: boolean,
//   isEdit: boolean,
//   isDel: boolean,
//   isView: boolean,
//   isPrint: boolean,
//   isExport: boolean,
//   isRelease: boolean,
//   isPost: boolean
// ): any {
//   return {
//     roleId,
//     menuId,
//     menuName,
//     parentId,
//     // pageUrl,
//     // icon,
//     // displayNo,
//     // isMenu,
//     isAdd,
//     isEdit,
//     isDel,
//     isView,
//     isPrint,
//     isExport,
//     isRelease,
//     isPost,

//   };
// }

// interface MenuPermission {
//   isAdd: boolean;
//   isEdit: boolean;
//   isPrint: boolean;
//   isDel: boolean;
// }

// export default function UserPermissionMaster() {
//   const [page, setPage] = useState(0);
//   const {defaultValuestime}=getISTDate();
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [rows, setRows] = useState<any>([]);
//   const [records, setRecords] = useState(rows);
//   const [childMenuRecords, setChildMenuRecords] = useState(rows);
//   const [roleOption, setRoleOption] = useState([
//     { value: "-1", label: "Select Role Name" },
//   ]);
//   const [empOption, setempOption] = useState([
//     { value: -1, label: ("text.empid") },
//   ]);
//   const { i18n, t } = useTranslation();
//   const [users, setUsers] = useState<any>([]);
//   const [employeeId, setEmployeeId] = useState<string>("");

//   const [enteredEmployeeName, setEnteredEployeeName] = useState<any>("");
//   const [enteredRoleName, setEnteredRoleName] =
//     React.useState<FilmOptionType | null>(null);
//   const [selectedRoleID, setSelectedRoleID] = useState(enteredRoleName?.value);
//   const [selectedRoleData, setSelectedRoleData] = useState([]);

//   const [isLoading, setIsLoading] = useState(true);
//   const [permissionData, setPermissionData] = useState<MenuPermission>({
//     isAdd: false,
//     isEdit: false,
//     isPrint: false,
//     isDel: false,
//   });
//   const [edit, setEditID] = useState(selectedRoleID);

//   const location = useLocation();

//   const handleUserChange = (event: React.ChangeEvent<{}>, newValue: any) => {
//     console.log(newValue?.ranK_ID);
//     // handleEmployeeIdChange(newValue?.value);
//     // console.log(enteredEmployeeName)
//     setEnteredEployeeName(newValue);
//     if (newValue) {
//       setEmployeeId(`${newValue.useR_ID}`);
//       setSelectedRoleID(`${newValue.ranK_ID}`);
//       getRolebyID(newValue.ranK_ID);
//     } else {
//       setEmployeeId("");
//     }
//   };

//   const handleEmployeeIdChange = (event: any) => {
//     const employeeIds = event.target.value;
//     console.log(employeeIds);

//     setEmployeeId(employeeIds);
//     const matchingUser = users.find(
//       (users: any) => `${users.useR_ID}` === employeeId
//     );



//     setEnteredEployeeName(
//       matchingUser
//         ? `${matchingUser.firsT_NAME} ${matchingUser.middlE_NAME} ${matchingUser.suR_NAME}`
//         : ""
//     );
//     // console.log(setEnteredEployeeName);
//     // console.log(enteredEmployeeName);
//   };
//   const formik = useFormik({
//     initialValues: {
//       "empid": 0,
//       "empName": "",
//       "empCode": "",
//       "empPerAddress": "",
//       "empLocalAddress": "",
//       "empFatherName": "",
//       "empspauseName": "",
//       "empMotherName": "",
//       "empMobileNo": "",
//       "empStatus": "",
//       "empPanNumber": "",
//       "empAddharNo": "",
//       "empDob": "2024-11-30T08:41:41.180Z",
//       "empJoiningDate": "2024-11-30T08:41:41.180Z",
//       "empretirementDate": "2024-11-30T08:41:41.180Z",
//       "empDesignationId": 0,
//       "empDeptId": 0,
//       "empStateId": 0,
//       "empCountryID": 0,
//       "empCityId": 0,
//       "empPincode": 0,
//       "createdBy": "",
//       "updatedBy": "",
//       "createdOn": "2024-11-30T08:41:41.180Z",
//       "updatedOn": "2024-11-30T08:41:41.180Z",
//       "userId": "",
//       "roleId": "",
//       "imageFile": "",
//       "signatureFile": "",
//       "email": "",
//       "dlno": "",
//       "gender": "",
//       "departmentName": "",
//       "designationName": "",
//       "empStateName": "",
//       "empCountryName": "",
//       "empCityName": "",
//       "srno": 0,
//       "empDepName": "",
//       "registerModel": {
//         // "id": "",
//         // "username": "",
//         // "email": "A@gmail.com",
//         // "password": "",
//         // "role": ""
//       },
//       "userPermission": [
//         {
//           // "userId": "",
//           // "menuId": 0,
//           // "parentId": 0,
//           // "isAdd": true,
//           // "isEdit": true,
//           // "isDel": true,
//           // "isView": true,
//           // "isPrint": true,
//           // "isExport": true,
//           // "isRelease": true,
//           // "isPost": true,
//           // "menuName": "",
//           // "parentMenuName": "",
//           // "path": "",
//           // "icon": "",
//           // "displayNo": 0,
//           // "parentDisplayNo": 0
//         }
//       ],
//       "checked": true
//     },

//     onSubmit: async (values: any) => {
//       values.rolePermissions = childMenuRecords;

//       const response = await api.post(`Employee/UpsertEmpPermission`, values);
//       if (response.data.status === 1) {
//           toast.success(response.data.message);
//           navigate("/UserManagement/UserPermissionMaster");
//           setOpen(false);
//         //  getList();
//       } else {
//           toast.error(response.data.message);
//       }
//   },

//   });

//   let delete_id = "";
//   useEffect(() => {
//     getroleData();

//     getempData();


//   }, []);



//   interface FilmOptionType {
//     label: string;
//     value: string;
//   }



//   const getempData = async () => {
//     const collectData = {
//       "orderby": "",
//       "pageNo": 0,
//       "pageSize": 0,
//       "intnotnullvalue1": 0,
//       "userId": "",

//       "str1": "",
//       "str2": "",
//       "str3": "",
//       "str4": "",
//       "str5": "",
//       "intvalue1": 0,
//       "intvalue2": 0,
//       "intvalue3": 0,
//       "intvalue4": 0,
//       "intnotnullvalue2": 0,
//       "intnotnullvalue3": 0,
//       "dec1": 0,
//       "dec2": 0,
//       "dec3": 0,
//       "dec4": 0,
//       "flag": true,
//       "data": "",
//       "success": true,
//       "error": "",
//       "selectPerindex": 0,
//       "show": true
//     };
//     const response = await api.post(`Employee/GetEmployee`, collectData);
//     const data = response.data.data;
//     const arr = [];
//     for (let index = 0; index < data.length; index++) {
//       arr.push({
//         label: data[index]["empName"],
//         value: data[index]["empid"],
//       });
//     }
//     setempOption(arr);
//   };

//   const getroleData = () => {

//     api
//       .get(`Auth/GetRoleMaster`,
//       )
//       .then((res) => {
//         const arr = [];
//         console.log("GetRoleMaster" + JSON.stringify(res.data.data));
//         for (let index = 0; index < res.data.data.length; index++) {
//           arr.push({
//             label: res.data.data[index]["name"],
//             value: res.data.data[index]["id"],
//           });
//         }
//         setRoleOption(arr);
//       });
//   };


//   const getModalList = () => {
//     api.post("Menu/GetChildMenuMaster").then((res) => {
//       const arr = [];

//       for (let index = 0; index < res.data.data.length; index++) {
//         arr.push(
//           childMenuCreateData(
//             "-1",

//             res.data.data[index]["menuId"],
//             res.data.data[index]["menuName"],
//             res.data.data[index]["parentId"],

//             res.data.data[index]["isAdd"],
//             res.data.data[index]["isEdit"],
//             res.data.data[index]["isDel"],
//             res.data.data[index]["isView"],
//             res.data.data[index]["isPrint"],
//             res.data.data[index]["isExport"],
//             res.data.data[index]["isRelease"],
//             res.data.data[index]["isPost"]
//           )
//         );
//       }

//       setRows(arr);
//       setChildMenuRecords(arr);

//     });
//   };

//   const getRolebyID = (id: any) => {
//     const collectData = {
//       roleId: id,
//     };
//     api.post("Auth/GetRoleMaster", collectData).then((res) => {
//       const arr = [];
//       // console.log("result get rolemaster" + JSON.stringify(res.data.data[0]["rolePermission"]));
//       for (
//         let index = 0;
//         index < res.data.data[0]["rolePermission"].length;
//         index++
//       ) {
//         arr.push(
//           childMenuCreateData(
//             "0",
//             res.data.data[0]["rolePermission"][index]["roleId"],
//             res.data.data[0]["rolePermission"][index]["menuId"],
//             res.data.data[0]["rolePermission"][index]["menuName"],

//             res.data.data[0]["rolePermission"][index]["isAdd"],
//             res.data.data[0]["rolePermission"][index]["isEdit"],
//             res.data.data[0]["rolePermission"][index]["isDel"],
//             res.data.data[0]["rolePermission"][index]["isView"],
//             res.data.data[0]["rolePermission"][index]["isPrint"],
//             res.data.data[0]["rolePermission"][index]["isExport"],
//             res.data.data[0]["rolePermission"][index]["isRelease"],
//             res.data.data[0]["rolePermission"][index]["isPost"]
//           )
//         );
//       }

//       setChildMenuRecords(null);
//       setChildMenuRecords(arr);

//     });
//   };


//   function handleFilter(event: any) {
//     const newRows = rows.filter((rowss: { userName: string }) => {
//       return rowss.userName
//         .toLowerCase()
//         .includes(event.target.value.toLowerCase());
//     });
//     setRecords(newRows);
//   }

//   const handleChangePage = (event: unknown, newPage: number) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (
//     event: React.ChangeEvent<HTMLInputElement>
//   ) => {
//     setRowsPerPage(+event.target.value);
//     setPage(0);
//   };

//   const [open, setOpen] = React.useState(false);
//   const handleClose = () => {
//     setEnteredEployeeName(null);
//     setEmployeeId("");
//     setEnteredRoleName(null);
//     setSelectedRoleID("");
//     setEditID("");
//     setOpen(false);
//     // setSelectedRoleData("");
//   };

//   const handleOpen = () => {
//     setEnteredEployeeName(null);
//     setEmployeeId("");
//     setEnteredRoleName(null);
//     setOpen(true);
//   };



//   const accept = () => {
//     const collectData = {
//       userId: "delete_id",
//     };

//     api
//       .post(
//         `Auth/DeleteUserPermissionMaster`,
//         collectData
//       )
//       .then((response) => {
//         if (response.data.isSuccess) {
//           toast.success(response.data.mesg);

//         } else {
//           toast.error(response.data.mesg);
//         }
//       });
//   };

//   const reject = () => {

//     toast.warn("Rejected: You have rejected", { autoClose: 3000 });
//   };

//   const handledeleteClick = (del_id: any) => {

//     delete_id = del_id;
//     confirmDialog({
//       message: "Do you want to delete this record ?",
//       header: "Delete Confirmation",
//       icon: "pi pi-info-circle",
//       acceptClassName: "p=-button-danger",
//       accept,
//       reject,
//     });
//   };

//   const routeChangeEdit = (row: any) => {
//     const matchingUser = users.find(
//       (users: any) => `${users.useR_ID}` === row.id
//     );

//     setEditID(row.id);
//     setOpen(true);
//     setEnteredEployeeName(matchingUser);
//     setEmployeeId(row.id);

//   };

//   let navigate = useNavigate();
//   const routeChangeAdd = () => {
//     let path = `/master/TaxMasterAdd`;
//     navigate(path);
//   };

//   const handleSelectAll = (value: string, evnt: any) => {
//     if (value == "isAdd") {
//       setSelectedRoleData((prevData: any) =>
//         prevData.map((item: any) => ({
//           ...item,
//           isAdd: evnt,
//         }))
//       );
//     } else if (value == "isEdit") {
//       setSelectedRoleData((prevData: any) =>
//         prevData.map((item: any) => ({
//           ...item,
//           isEdit: evnt,
//         }))
//       );
//     } else if (value == "isDel") {
//       setSelectedRoleData((prevData: any) =>
//         prevData.map((item: any) => ({
//           ...item,
//           isDel: evnt,
//         }))
//       );
//     } else if (value == "isView") {
//       setSelectedRoleData((prevData: any) =>
//         prevData.map((item: any) => ({
//           ...item,
//           isView: evnt,
//         }))
//       );
//     } else if (value == "isPrint") {
//       setSelectedRoleData((prevData: any) =>
//         prevData.map((item: any) => ({
//           ...item,
//           isPrint: evnt,
//         }))
//       );
//     } else if (value == "isExport") {
//       setSelectedRoleData((prevData: any) =>
//         prevData.map((item: any) => ({
//           ...item,
//           isExport: evnt,
//         }))
//       );
//     } else if (value == "isRelease") {
//       setSelectedRoleData((prevData: any) =>
//         prevData.map((item: any) => ({
//           ...item,
//           isRelease: evnt,
//         }))
//       );
//     } else if (value == "isPost") {
//       setSelectedRoleData((prevData: any) =>
//         prevData.map((item: any) => ({
//           ...item,
//           isPost: evnt,
//         }))
//       );
//     }
//   };


// const handleCheckboxChange = (id: any, header: string) => {
//     if (header == "isAdd") {
//       //   console.log(header)
//       // console.log(id)
//       setChildMenuRecords((prevData: any) =>
//         prevData.map((item: any) =>
//           item.menuId === id ? { ...item, isAdd: !item.isAdd } : item
//         )
//       );
//     } else if (header == "isEdit") {
//       setChildMenuRecords((prevData: any) =>
//         prevData.map((item: any) =>
//           item.menuId === id ? { ...item, isEdit: !item.isEdit } : item
//         )
//       );
//     } else if (header == "isDel") {
//       setChildMenuRecords((prevData: any) =>
//         prevData.map((item: any) =>
//           item.menuId === id ? { ...item, isDel: !item.isDel } : item
//         )
//       );
//     } else if (header == "isView") {
//       setChildMenuRecords((prevData: any) =>
//         prevData.map((item: any) =>
//           item.menuId === id ? { ...item, isView: !item.isView } : item
//         )
//       );
//     } else if (header == "isPrint") {
//       setChildMenuRecords((prevData: any) =>
//         prevData.map((item: any) =>
//           item.menuId === id ? { ...item, isPrint: !item.isPrint } : item
//         )
//       );
//     } else if (header == "isExport") {
//       setChildMenuRecords((prevData: any) =>
//         prevData.map((item: any) =>
//           item.menuId === id ? { ...item, isExport: !item.isExport } : item
//         )
//       );
//     } else if (header == "isRelease") {
//       setChildMenuRecords((prevData: any) =>
//         prevData.map((item: any) =>
//           item.menuId === id ? { ...item, isRelease: !item.isRelease } : item
//         )
//       );
//     } else if (header == "isPost") {
//       setChildMenuRecords((prevData: any) =>
//         prevData.map((item: any) =>
//           item.menuId === id ? { ...item, isPost: !item.isPost } : item
//         )
//       );
//     }
//   };


//   const selectedroleMasterSubmitHandler = (event: {
//     preventDefault: () => void;
//   }) => {
//     event.preventDefault();
//     const collectData = {
//       // userId: employeeId,

//         "empid": 0,
//         "empName": "",
//         "empCode": "",
//         "empPerAddress": "",
//         "empLocalAddress": "",
//         "empFatherName": "",
//         "empspauseName": "",
//         "empMotherName": "",
//         "empMobileNo": "",
//         "empStatus": "",
//         "empPanNumber": "",
//         "empAddharNo": "",
//         "empDob": defaultValuestime,
//         "empJoiningDate": defaultValuestime,
//         "empretirementDate": defaultValuestime,
//         "empDesignationId": 0,
//         "empDeptId": 0,
//         "empStateId": 0,
//         "empCountryID": 0,
//         "empCityId": 0,
//         "empPincode": 0,
//         "createdBy": "",
//         "updatedBy": "",
//         "createdOn":defaultValuestime,
//         "updatedOn": defaultValuestime,
//         "userId": "",
//         "roleId": "",
//         "imageFile": "",
//         "signatureFile": "",
//         "email": "",
//         "dlno": "",
//         "gender": "",
//         "departmentName": "",
//         "designationName": "",
//         "empStateName": "",
//         "empCountryName": "",
//         "empCityName": "",
//         "srno": 0,
//         "empDepName": "",
//         "registerModel": {
//           "id": "",
//           "username": "",
//           "email": "",
//           "password": "",
//           "role": ""
//         },
//         "userPermission": [
//           {
//             "userId": "",
//             "menuId": 0,
//             "parentId": 0,
//             "isAdd": true,
//             "isEdit": true,
//             "isDel": true,
//             "isView": true,
//             "isPrint": true,
//             "isExport": true,
//             "isRelease": true,
//             "isPost": true,
//             "menuName": "",
//             "parentMenuName": "",
//             "path": "",
//             "icon": "",
//             "displayNo": 0,
//             "parentDisplayNo": 0
//           }
//         ],
//         "checked": true


//       //userPermission: selectedRoleData,
//     };
//     // console.log(collectData);
//     api
//       .post(
//         "Employee/UpsertEmpPermission",
//         collectData
//       )
//       .then((res) => {
//         if (res.data.status===1) {
//           toast.success(res.data.message);
//           setEnteredRoleName(null);
//           setEnteredEployeeName(null);

//           setOpen(false);
//           let path =`/UserManagement/UserPermissionMaster`;
//          // getList();
//           navigate(path);
//         } else {
//           toast.error(res.data.mesg);
//         }
//       });
//   };



//   return (
//     <>
//       <Card
//         style={{
//           width: "100%",
//           // height: "100%",
//           backgroundColor: "#E9FDEE",
//           border: ".5px solid #FF7722 ",
//           marginTop: "3vh",
//         }}
//       >
//         <Paper
//           sx={{
//             width: "100%",
//             overflow: "hidden",
//             "& .MuiDataGrid-colCell": {
//               backgroundColor: `var(--grid-headerBackground)`,
//               color: `var(--grid-headerColor)`,
//               fontSize: 17,
//               fontWeight: 900,
//             },
//           }}
//           style={{ padding: "10px" }}
//         >
//           <ConfirmDialog />

//           <Typography
//             gutterBottom
//             variant="h5"
//             component="div"
//             sx={{ padding: "20px" }}
//             align="left"
//           >
//             {t("text.UserPermissionMaster")}
//           </Typography>
//           <Divider />

//           <Box height={10} />

//           <Stack direction="row" spacing={2} classes="my-2 mb-2">
//             {/*permissionData?.isAdd == true && ( */}
//             <Button
//               onClick={handleOpen}
//               variant="contained"
//               endIcon={<AddCircleIcon />}
//               size="large"
//               style={{ backgroundColor: `var(--header-background)` }}
//             >
//               {t("text.add")}
//             </Button>
//             {/*)} */}


//           </Stack>

//           <Modal open={open}>
//             <Box sx={style}>
//               <form
//                 onSubmit={selectedroleMasterSubmitHandler}
//               // onReset={rolemasterResetHandler}
//               >
//                 <IconButton
//                   aria-label="close"
//                   onClick={handleClose}
//                   sx={{
//                     position: "absolute",
//                     right: 10,
//                     top: 8,
//                     color: (theme) => theme.palette.grey[900],
//                   }}
//                 >
//                   <CloseIcon />
//                 </IconButton>
//                 <Grid
//                   container
//                   spacing={2}
//                   style={{ marginTop: "1px", marginBottom: "1px" }}
//                 >




//               <Grid item xs={12} sm={4} lg={4}>
//                 <Autocomplete
//                   disablePortal
//                   id="combo-box-demo"
//                   options={empOption}
//                   fullWidth
//                   size="small"
//                   onChange={(event, newValue) => {
//                     console.log(newValue?.value);
//                     formik.setFieldValue("empName", newValue?.label);
//                     formik.setFieldValue("empid", newValue?.value);
//                   }}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={<CustomLabel text={t("text.selectempname")} />}
//                     />
//                   )}
//                 />
//               </Grid>



//                   <Grid item xs={12} sm={4} lg={4}>
//                     <TextField
//                       label={<CustomLabel text={t("text.userid")} required={true} />}
//                       variant="outlined"
//                       fullWidth
//                       size="small"
//                       name="username"
//                       id="username"
//                      value={formik.values.username}
//                       placeholder={t("text.userid")}
//                    onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     />

//                   </Grid>


//                   <Grid item xs={12} sm={4} lg={4}>
//                     <TextField
//                       label={<CustomLabel text={t("text.password")} required={true} />}
//                       variant="outlined"
//                       fullWidth
//                       size="small"
//                       name="password"
//                       id="password"
//                        value={formik.values.password}
//                       placeholder={t("text.password")}
//                      onChange={formik.handleChange}
//                      onBlur={formik.handleBlur}
//                     />

//                   </Grid>



//               <Grid item xs={12} sm={4} lg={4}>
//                 <Autocomplete
//                   disablePortal
//                   id="combo-box-demo"
//                   options={roleOption}
//                   fullWidth
//                   size="small"
//                   onChange={(event, newValue) => {
//                     console.log(newValue?.value);
//                     formik.setFieldValue("role", newValue?.label);
//                     formik.setFieldValue("roleId", newValue?.value);
//                   }}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={<CustomLabel text={t("text.role")} />}
//                     />
//                   )}
//                 />
//               </Grid>





//                   <Grid item lg={4} sm={4}>
//                     <Grid>
//                       <Button
//                         type="submit"
//                         fullWidth
//                         style={{
//                           backgroundColor: `var(--header-background)`,
//                           color: `var(--header-color)`,
//                           marginBottom: "10px",
//                           marginTop: "3px",
//                         }}
//                       >
//                         {edit == selectedRoleID
//                           ? t("text.save")
//                           : t("text.update")}
//                       </Button>
//                     </Grid>
//                   </Grid>

//                   <Grid item lg={4} sm={4}>
//                     <Button
//                       type="reset"
//                       fullWidth
//                       style={{
//                         backgroundColor: "#F43F5E",
//                         color: "white",
//                         marginBottom: "10px",
//                         marginTop: "3px",
//                       }}
//                     >
//                       {t("text.reset")}
//                     </Button>
//                   </Grid>
//                 </Grid>
//                 <Grid container spacing={2}>
//                   <Grid md={12} item>
//                     <Grid style={{}}>
//                       <TableContainer sx={{ maxHeight: "65vh" }}>
//                         <table
//                           style={{
//                             width: "100%",
//                             border: "1px solid black",
//                             borderCollapse: "collapse",
//                           }}
//                         >
//                           <thead>
//                             <tr
//                               style={{
//                                 border: "1px solid black",
//                                 fontSize: "2.7vh",
//                                 fontWeight: "500",
//                                 backgroundColor: `var(--header-background)`,
//                                 color: `var(--header-color)`,
//                                 textAlign: "center",
//                               }}
//                             >
//                               {/* <td>Sr. No.</td> */}
//                               <td>{t("text.MenuName")}</td>
//                               <td>{t("text.ParentName")}</td>
//                               <td>
//                                 {t("text.add")}
//                                 <br />
//                                 <input
//                                   type="checkbox"
//                                   style={{
//                                     marginLeft: "10px",
//                                     marginRight: "10px",
//                                   }}
//                                   checked={
//                                     selectedRoleData.length > 0
//                                       ? selectedRoleData.every(
//                                         (item: any) => item.isAdd
//                                       )
//                                       : false
//                                   }
//                                   defaultChecked={false}
//                                   onChange={(e) =>
//                                     handleSelectAll("isAdd", e.target.checked)
//                                   }
//                                 />
//                               </td>
//                               <td>
//                                 {t("text.Edit")}
//                                 <br />
//                                 <input
//                                   type="checkbox"
//                                   style={{
//                                     marginLeft: "10px",
//                                     marginRight: "10px",
//                                   }}
//                                   checked={
//                                     selectedRoleData.length > 0
//                                       ? selectedRoleData.every(
//                                         (item: any) => item.isEdit
//                                       )
//                                       : false
//                                   }
//                                   onChange={(e) =>
//                                     handleSelectAll("isEdit", e.target.checked)
//                                   }
//                                 />
//                               </td>
//                               <td>
//                                 {t("text.delete")}
//                                 <br />
//                                 <input
//                                   type="checkbox"
//                                   style={{
//                                     marginLeft: "10px",
//                                     marginRight: "10px",
//                                   }}
//                                   checked={
//                                     selectedRoleData.length > 0
//                                       ? selectedRoleData.every(
//                                         (item: any) => item.isDel
//                                       )
//                                       : false
//                                   }
//                                   onChange={(e) =>
//                                     handleSelectAll("isDel", e.target.checked)
//                                   }
//                                 />
//                               </td>
//                               <td>
//                                 {t("text.View")}
//                                 <br />
//                                 <input
//                                   type="checkbox"
//                                   style={{
//                                     marginLeft: "10px",
//                                     marginRight: "10px",
//                                   }}
//                                   checked={
//                                     selectedRoleData.length > 0
//                                       ? selectedRoleData.every(
//                                         (item: any) => item.isView
//                                       )
//                                       : false
//                                   }
//                                   onChange={(e) =>
//                                     handleSelectAll("isView", e.target.checked)
//                                   }
//                                 />
//                               </td>
//                               <td>
//                                 {t("text.Print")}
//                                 <br />
//                                 <input
//                                   type="checkbox"
//                                   style={{
//                                     marginLeft: "10px",
//                                     marginRight: "10px",
//                                   }}
//                                   checked={
//                                     selectedRoleData.length > 0
//                                       ? selectedRoleData.every(
//                                         (item: any) => item.isPrint
//                                       )
//                                       : false
//                                   }
//                                   onChange={(e) =>
//                                     handleSelectAll("isPrint", e.target.checked)
//                                   }
//                                 />
//                               </td>
//                               <td>
//                                 {t("text.Export")}
//                                 <br />
//                                 <input
//                                   type="checkbox"
//                                   style={{
//                                     marginLeft: "10px",
//                                     marginRight: "10px",
//                                   }}
//                                   checked={
//                                     selectedRoleData.length > 0
//                                       ? selectedRoleData.every(
//                                         (item: any) => item.isExport
//                                       )
//                                       : false
//                                   }
//                                   onChange={(e) =>
//                                     handleSelectAll(
//                                       "isExport",
//                                       e.target.checked
//                                     )
//                                   }
//                                 />
//                               </td>
//                               <td>
//                                 {t("text.Release")}
//                                 <br />
//                                 <input
//                                   type="checkbox"
//                                   style={{
//                                     marginLeft: "10px",
//                                     marginRight: "10px",
//                                   }}
//                                   checked={
//                                     selectedRoleData.length > 0
//                                       ? selectedRoleData.every(
//                                         (item: any) => item.isRelease
//                                       )
//                                       : false
//                                   }
//                                   onChange={(e) =>
//                                     handleSelectAll(
//                                       "isRelease",
//                                       e.target.checked
//                                     )
//                                   }
//                                 />
//                               </td>
//                               <td>
//                                 {t("text.Post")}
//                                 <br />
//                                 <input
//                                   type="checkbox"
//                                   style={{
//                                     marginLeft: "10px",
//                                     marginRight: "10px",
//                                   }}
//                                   checked={
//                                     selectedRoleData.length > 0
//                                       ? selectedRoleData.every(
//                                         (item: any) => item.isPost
//                                       )
//                                       : false
//                                   }
//                                   onChange={(e) =>
//                                     handleSelectAll("isPost", e.target.checked)
//                                   }
//                                 />
//                               </td>
//                             </tr>
//                           </thead>
//                           <tbody style={{ color: "black" }}>
//                             {selectedRoleData.map(
//                               (rows: any, key: string | number | any) => {
//                                 return (
//                                   <>
//                                     {
//                                       <tr
//                                         style={{
//                                           border: "1px solid black",
//                                           fontSize: "2.7vh",

//                                         }}
//                                       >

//                                         <td
//                                           style={{
//                                             padding: "10px",
//                                             textAlign: "center",
//                                           }}
//                                         >
//                                           {rows.menuName}
//                                         </td>
//                                         <td
//                                           style={{
//                                             padding: "10px",
//                                             textAlign: "center",
//                                           }}
//                                         >
//                                           {rows.parentMenuName}
//                                         </td>
//                                         <td>
//                                           <input
//                                             type="checkbox"
//                                             checked={
//                                               selectedRoleData[key]["isAdd"]
//                                                 ? true
//                                                 : false
//                                             }
//                                             name="isAdd"
//                                             className="isAdd"
//                                             style={{
//                                               marginLeft: "20px",
//                                               marginRight: "20px",
//                                             }}
//                                             // aria-checked={selectedRoleData.every((item:any) =>  item.isAdd)}
//                                             onChange={(e) =>
//                                               handleCheckboxChange(
//                                                 rows.menuId,
//                                                 "isAdd"
//                                               )
//                                             }
//                                           />
//                                         </td>
//                                         <td>
//                                           <input
//                                             type="checkbox"
//                                             checked={
//                                               selectedRoleData[key]["isEdit"]
//                                                 ? true
//                                                 : false
//                                             }
//                                             name="isEdit"
//                                             className="isEdit"
//                                             style={{
//                                               marginLeft: "20px",
//                                               marginRight: "20px",
//                                             }}
//                                             // aria-checked={selectedRoleData.every((item:any) =>  item.isEdit)}
//                                             onChange={(e) =>
//                                               handleCheckboxChange(
//                                                 rows.menuId,
//                                                 "isEdit"
//                                               )
//                                             }
//                                           />
//                                         </td>
//                                         <td>
//                                           <input
//                                             type="checkbox"
//                                             checked={
//                                               selectedRoleData[key]["isDel"]
//                                                 ? true
//                                                 : false
//                                             }
//                                             name="isDel"
//                                             className="isDel"
//                                             style={{
//                                               marginLeft: "20px",
//                                               marginRight: "20px",
//                                             }}
//                                             // aria-aria-checked={selectedRoleData.every((item:any) =>  item.isDel)}
//                                             onChange={(e) =>
//                                               handleCheckboxChange(
//                                                 rows.menuId,
//                                                 "isDel"
//                                               )
//                                             }
//                                           />
//                                         </td>
//                                         <td>
//                                           <input
//                                             type="checkbox"
//                                             checked={
//                                               selectedRoleData[key]["isView"]
//                                                 ? true
//                                                 : false
//                                             }
//                                             name="isView"
//                                             className="isView"
//                                             style={{
//                                               marginLeft: "20px",
//                                               marginRight: "20px",
//                                             }}
//                                             // aria-checked={selectedRoleData.every((item:any) =>  item.isView)}
//                                             onChange={(e) =>
//                                               handleCheckboxChange(
//                                                 rows.menuId,
//                                                 "isView"
//                                               )
//                                             }
//                                           />
//                                         </td>
//                                         <td>
//                                           <input
//                                             type="checkbox"
//                                             checked={
//                                               selectedRoleData[key]["isPrint"]
//                                                 ? true
//                                                 : false
//                                             }
//                                             name="isPrint"
//                                             className="isPrint"
//                                             style={{
//                                               marginLeft: "20px",
//                                               marginRight: "20px",
//                                             }}
//                                             // aria-checked={selectedRoleData.every((item:any) =>  item.isPrint)}
//                                             onChange={(e) =>
//                                               handleCheckboxChange(
//                                                 rows.menuId,
//                                                 "isPrint"
//                                               )
//                                             }
//                                           />
//                                         </td>
//                                         <td>
//                                           <input
//                                             type="checkbox"
//                                             checked={
//                                               selectedRoleData[key]["isExport"]
//                                                 ? true
//                                                 : false
//                                             }
//                                             name="isExport"
//                                             className="isExport"
//                                             style={{
//                                               marginLeft: "25px",
//                                               marginRight: "25px",
//                                             }}
//                                             // aria-checked={selectedRoleData.every((item:any) =>  item.isExport)}
//                                             onChange={(e) =>
//                                               handleCheckboxChange(
//                                                 rows.menuId,
//                                                 "isExport"
//                                               )
//                                             }
//                                           />
//                                         </td>
//                                         <td>
//                                           <input
//                                             type="checkbox"
//                                             checked={
//                                               selectedRoleData[key]["isRelease"]
//                                                 ? true
//                                                 : false
//                                             }
//                                             name="isRelease"
//                                             className="isRelease"
//                                             style={{
//                                               marginLeft: "25px",
//                                               marginRight: "25px",
//                                             }}
//                                             // aria-checked={selectedRoleData.every((item:any) =>  item.isRelease)}
//                                             onChange={(e) =>
//                                               handleCheckboxChange(
//                                                 rows.menuId,
//                                                 "isRelease"
//                                               )
//                                             }
//                                           />
//                                         </td>
//                                         <td>
//                                           <input
//                                             type="checkbox"
//                                             checked={
//                                               selectedRoleData[key]["isPost"]
//                                                 ? true
//                                                 : false
//                                             }
//                                             name="isPost"
//                                             className="isPost"
//                                             style={{
//                                               marginLeft: "20px",
//                                               marginRight: "20px",
//                                             }}
//                                             // aria-checked={selectedRoleData.every((item:any) =>  item.isPost)}
//                                             onChange={(e) =>
//                                               handleCheckboxChange(
//                                                 rows.menuId,
//                                                 "isPost"
//                                               )
//                                             }
//                                           />
//                                         </td>
//                                       </tr>
//                                     }
//                                   </>
//                                 );
//                               }
//                             )}
//                           </tbody>
//                         </table>
//                       </TableContainer>
//                     </Grid>
//                   </Grid>
//                 </Grid>
//               </form>
//             </Box>
//           </Modal>

//           {isLoading ? (
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <CircularProgress />
//             </div>
//           ) : (
//             <Box>
//               <br />

//             </Box>
//           )}
//         </Paper>
//       </Card>

//       <ToastApp />
//     </>
//   );
// }

import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Divider,
  InputAdornment,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import PrintIcon from "@mui/icons-material/Print";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import HOST_URL from "../../../utils/Url";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import api from "../../../utils/Url";
import { getISTDate } from "../../../utils/Constant";
import CustomLabel from "../../../CustomLable";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "180vh",
  height: "90vh",
  bgcolor: "#f5f5f5",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 3,
  overflowX: "auto",
};

function createData(
  srno: number,
  id: string,
  name: string
  // rolePermission: string
): any {
  return { srno, id, name };
}

function childMenuCreateData(


  // "userId": "",
  //     "menuId": 2,
  //     "parentId": 1,
  //     "isAdd": true,
  //     "isEdit": true,
  //     "isDel": true,
  //     "isView": true,
  //     "isPrint": true,
  //     "isExport": true,
  //     "isRelease": true,
  //     "isPost": false,
  //     "menuName": "",
  //     "parentMenuName": "",
  //     "path": "",
  //     "icon": "",
  //     "displayNo": 0,
  //     "parentDisplayNo": 0
  //userId:any,    
  userId: any,
  menuId: string,
  menuName: string,
  parentId: number,
  isAdd: boolean,
  isEdit: boolean,
  isDel: boolean,
  isView: boolean,
  isPrint: boolean,
  isExport: boolean,
  isRelease: boolean,
  isPost: boolean,
  // parentMenuName:string,
  // path:any,
  // icon:any,
  // displayNo: number,
  // parentDisplayNo: number

): any {
  return {
    // userId,
    userId,
    menuId,
    menuName,
    parentId,
    isAdd,
    isEdit,
    isDel,
    isView,
    isPrint,
    isExport,
    isRelease,
    isPost,
    // parentMenuName,
    // path,
    // icon,
    // displayNo,
    // parentDisplayNo,
  };
}

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

export default function UserPermissionMaster() {

  const [roleOption, setRoleOption] = useState([
    { value: "-1", label: "Select Role Name" },
  ]);
  const [empOption, setempOption] = useState([
    { value: -1, label: ("text.empid") },
  ]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rows, setRows] = useState<any>([]);
  const [records, setRecords] = useState(rows);
  const [childMenuRecords, setChildMenuRecords] = useState(rows);
  const [enteredrolename, setEnteredrolename] = useState("");
  const [editID, setEditID] = useState("-1");
  const [isLoading, setIsLoading] = useState(true);
  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
  });

  const location = useLocation();
  const { i18n, t } = useTranslation();
  const { defaultValues } = getISTDate();

  const [showPassword, setShowPassword] = useState(false);


  const generateRandomPassword = () => {
    const length = 8;
    const lowercaseCharset = "abcdefghijklmnopqrstuvwxyz";
    const uppercaseCharset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numberCharset = "0123456789";
    const specialCharset = "!@#$%^&*()";


    let password = "";
    password += lowercaseCharset.charAt(Math.floor(Math.random() * lowercaseCharset.length));
    password += uppercaseCharset.charAt(Math.floor(Math.random() * uppercaseCharset.length));
    password += numberCharset.charAt(Math.floor(Math.random() * numberCharset.length));
    password += specialCharset.charAt(Math.floor(Math.random() * specialCharset.length));

    // Fill in the rest of the password randomly from the combined character sets
    const combinedCharset = lowercaseCharset + uppercaseCharset + numberCharset + specialCharset;
    for (let i = password.length; i < length; i++) {
      password += combinedCharset.charAt(Math.floor(Math.random() * combinedCharset.length));
    }

    // Shuffle the password to make the order more random
    password = password.split("").sort(() => Math.random() - 0.5).join("");

    return password;
  };


  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  // Handle password generation
  const handleGeneratePassword = () => {
    const newPassword = generateRandomPassword();
    formik.setFieldValue("registerModel.password", newPassword);
  };


  function handleFilter(event: any) {
    const newRows = rows.filter((rowss: { roleName: string }) => {
      return rowss.roleName
        .toLowerCase()
        .includes(event.target.value.toLowerCase());
    });
    setRecords(newRows);
  }

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const nameChangeHandler = (event: any) => {
    setEnteredrolename(event.target.value);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const getroleData = () => {

    api
      .get(`Auth/GetRoleMaster`,
      )
      .then((res) => {
        const arr = [];
        console.log("GetRoleMaster" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["name"],
            value: res.data.data[index]["id"],
          });
        }
        setRoleOption(arr);
      });
  };


  const getempData = async () => {
    const collectData = {
      "orderby": "",
      "pageNo": 0,
      "pageSize": 0,
      "intnotnullvalue1": 0,
      "userId": "",

      "str1": "",
      "str2": "",
      "str3": "",
      "str4": "",
      "str5": "",
      "intvalue1": 0,
      "intvalue2": 0,
      "intvalue3": 0,
      "intvalue4": 0,
      "intnotnullvalue2": 0,
      "intnotnullvalue3": 0,
      "dec1": 0,
      "dec2": 0,
      "dec3": 0,
      "dec4": 0,
      "flag": true,
      "data": "",
      "success": true,
      "error": "",
      "selectPerindex": 0,
      "show": true
    };
    const response = await api.post(`Employee/GetEmployee`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["empName"],
        value: data[index]["empid"],
        userId: data[index]["userId"],
      });
    }
    setempOption(arr);
  };
  useEffect(() => {
    getroleData();
    getempData();
  }, []);


  const validationSchema = Yup.object({
    registerModel: Yup.object({
      password: Yup.string()
        .min(8, "Password must be at least 8 characters long")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[0-9]/, "Password must contain at least one number")
        .matches(/[@$!%*?&]/, "Password must contain at least one special character")
        .required("Password is required"),
    }),
  });


  const formik: any = useFormik({
    initialValues: {
      "empid": 0,
      "empName": "",
      // "empCode": "",
      // "empPerAddress": "",
      // "empLocalAddress": "",
      // "empFatherName": "",
      // "empspauseName": "",
      // "empMotherName": "",
      // "empMobileNo": "",
      // "empStatus": "",
      // "empPanNumber": "",
      // "empAddharNo": "",
      // "empDob": defaultValues,
      // "empJoiningDate": defaultValues,
      // "empretirementDate": defaultValues,
      // "empDesignationId": 0,
      // "empDeptId": 0,
      // "empStateId": 0,
      // "empCountryID": 0,
      // "empCityId": 0,
      // "empPincode": 0,
      // "createdBy": "",
      // "updatedBy": "",
      // "createdOn": defaultValues,
      // "updatedOn":defaultValues,
      "userId": "",
      "roleId": "",
      // "imageFile": "",
      // "signatureFile": "",
      // "email": "",
      // "dlno": "",
      // "gender": "",
      // "departmentName": "",
      // "designationName": "",
      // "empStateName": "",
      // "empCountryName": "",
      // "empCityName": "",
      // "srno": 0,
      // "empDepName": "",
      "registerModel": {
        "id": "",
        "username": "",
        "email": "user@example.com",
        "password": "",
        "role": ""
      },
      "userPermission": [],
      "checked": true,

    },
    validationSchema: validationSchema,
    onSubmit: async (values: any) => {

      //values.registerModel.username = formik.values.userId
      values.userPermission = childMenuRecords;
      if (editID !== "-1") {
        values.roleId = editID; // Include the roleId for updating
      }
      const response = await api.post(`Employee/UpsertEmpPermission`, values);
      if (response.data.status === 1) {
        toast.success(response.data.message);
        navigate("/admin/security/userpremission");
        formik.resetForm();
        setOpen(false);
        getList();
      } else {
        toast.error(response.data.message);
      }
    },

  });


  const getPasswordSuggestions = () => {
    const { password } = formik.values.registerModel;
    const suggestions = [];

    // Step-by-step validation checks
    if (!/[a-z]/.test(password)) {
      suggestions.push("At least one lowercase letter");
    } else if (!/[A-Z]/.test(password)) {
      suggestions.push("At least one uppercase letter");
    } else if (!/[0-9]/.test(password)) {
      suggestions.push("At least one number");
    } else if (!/[@$!%*?&]/.test(password)) {
      suggestions.push("At least one special character");
    }

    return suggestions;
  };

  const passwordSuggestions = getPasswordSuggestions();


  //  const requiredFields = ["roleName"];
  useEffect(() => {
    getList();
  }, []);

  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setEnteredrolename("");
    setEditID("-1");
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
    //getModalList();
  };

  const getList = () => {
    api.get("Auth/GetRoleMaster").then((res) => {
      const arr = [];
      // console.log("result" + JSON.stringify(res.data.data));
      for (let index = 0; index < res.data.data.length; index++) {
        arr.push(
          createData(
            index + 1,
            res.data.data[index]["id"],
            res.data.data[index]["name"]
            //res.data.data[index]["rolePermission"]
          )
        );
      }
      // console.log(arr);
      setRows(arr);
      setRecords(arr);
      // console.log(records);
      setIsLoading(false);
    });
  };

  // const getModalList = () => {


  // const collectData = {
  //   RoleId: -1,
  // };

  //   api.get("Auth/GetRolePermission",{params:collectData}).then((res) => {
  //     const arr = [];

  //     for (let index = 0; index < res.data.data.length; index++) {
  //       arr.push(
  //         childMenuCreateData(
  //           "-1",

  //           res.data.data[index]["menuId"],
  //           res.data.data[index]["menuName"],
  //           res.data.data[index]["parentId"],

  //           res.data.data[index]["isAdd"],
  //           res.data.data[index]["isEdit"],
  //           res.data.data[index]["isDel"],
  //           res.data.data[index]["isView"],
  //           res.data.data[index]["isPrint"],
  //           res.data.data[index]["isExport"],
  //           res.data.data[index]["isRelease"],
  //           res.data.data[index]["isPost"]
  //         )
  //       );
  //     }

  //     setRows(arr);
  //     setChildMenuRecords(arr);

  //   });
  // };



  const getModalListByRole = (roleId: any) => {


    const collectData = {
      RoleId: roleId,
    };

    api.get("Auth/GetRolePermission", { params: collectData }).then((res) => {
      const arr = [];

      for (let index = 0; index < res.data.data.length; index++) {
        arr.push(
          childMenuCreateData(
            "-1",

            res.data.data[index]["menuId"],
            res.data.data[index]["menuName"],
            res.data.data[index]["parentId"],

            res.data.data[index]["isAdd"],
            res.data.data[index]["isEdit"],
            res.data.data[index]["isDel"],
            res.data.data[index]["isView"],
            res.data.data[index]["isPrint"],
            res.data.data[index]["isExport"],
            res.data.data[index]["isRelease"],
            res.data.data[index]["isPost"]
          )
        );
      }

      setRows(arr);
      setChildMenuRecords(arr);

    });
  };

  // const getModalListByUser = (UserId:any) => {




  //     api.get(`Auth/GetUserPermission?UserId=${UserId}&RoleId=-1`).then((res) => {
  //       const arr = [];

  //       for (let index = 0; index < res.data.data.length; index++) {
  //         arr.push(
  //           childMenuCreateData(
  //             "-1",

  //             res.data.data[index]["menuId"],
  //             res.data.data[index]["menuName"],
  //             res.data.data[index]["parentId"],

  //             res.data.data[index]["isAdd"],
  //             res.data.data[index]["isEdit"],
  //             res.data.data[index]["isDel"],
  //             res.data.data[index]["isView"],
  //             res.data.data[index]["isPrint"],
  //             res.data.data[index]["isExport"],
  //             res.data.data[index]["isRelease"],
  //             res.data.data[index]["isPost"]
  //           )
  //         );
  //       }

  //       setRows(arr);
  //       setChildMenuRecords(arr);

  //     });
  //   };

  const findArrayElementByTitle = (array: any[], title: any) => {
    return array.find((element) => {
      return element.id === title;
    });
  };

  const routeChangeEdit = (row: any) => {

    console.log(row.roleName);


    setEditID(row.id);
    setOpen(true);

    formik.setFieldValue("roleName", row.name);

  };


  let navigate = useNavigate();

  const handleSelectAll = (value: string, evnt: any) => {

    if (value == "isAdd") {
      setChildMenuRecords((prevData: any) =>
        prevData.map((item: any) => ({
          ...item,
          isAdd: evnt,
        }))
      );
    } else if (value == "isEdit") {
      setChildMenuRecords((prevData: any) =>
        prevData.map((item: any) => ({
          ...item,
          isEdit: evnt,
        }))
      );
    } else if (value == "isDel") {
      setChildMenuRecords((prevData: any) =>
        prevData.map((item: any) => ({
          ...item,
          isDel: evnt,
        }))
      );
    } else if (value == "isView") {
      setChildMenuRecords((prevData: any) =>
        prevData.map((item: any) => ({
          ...item,
          isView: evnt,
        }))
      );
    } else if (value == "isPrint") {
      setChildMenuRecords((prevData: any) =>
        prevData.map((item: any) => ({
          ...item,
          isPrint: evnt,
        }))
      );
    } else if (value == "isExport") {
      setChildMenuRecords((prevData: any) =>
        prevData.map((item: any) => ({
          ...item,
          isExport: evnt,
        }))
      );
    } else if (value == "isRelease") {
      setChildMenuRecords((prevData: any) =>
        prevData.map((item: any) => ({
          ...item,
          isRelease: evnt,
        }))
      );
    } else if (value == "isPost") {
      setChildMenuRecords((prevData: any) =>
        prevData.map((item: any) => ({
          ...item,
          isPost: evnt,
        }))
      );
    }
  };

  const handleCheckboxChange = (id: any, header: string) => {
    if (header == "isAdd") {

      setChildMenuRecords((prevData: any) =>
        prevData.map((item: any) =>
          item.menuId === id ? { ...item, isAdd: !item.isAdd } : item
        )
      );
    } else if (header == "isEdit") {
      setChildMenuRecords((prevData: any) =>
        prevData.map((item: any) =>
          item.menuId === id ? { ...item, isEdit: !item.isEdit } : item
        )
      );
    } else if (header == "isDel") {
      setChildMenuRecords((prevData: any) =>
        prevData.map((item: any) =>
          item.menuId === id ? { ...item, isDel: !item.isDel } : item
        )
      );
    } else if (header == "isView") {
      setChildMenuRecords((prevData: any) =>
        prevData.map((item: any) =>
          item.menuId === id ? { ...item, isView: !item.isView } : item
        )
      );
    } else if (header == "isPrint") {
      setChildMenuRecords((prevData: any) =>
        prevData.map((item: any) =>
          item.menuId === id ? { ...item, isPrint: !item.isPrint } : item
        )
      );
    } else if (header == "isExport") {
      setChildMenuRecords((prevData: any) =>
        prevData.map((item: any) =>
          item.menuId === id ? { ...item, isExport: !item.isExport } : item
        )
      );
    } else if (header == "isRelease") {
      setChildMenuRecords((prevData: any) =>
        prevData.map((item: any) =>
          item.menuId === id ? { ...item, isRelease: !item.isRelease } : item
        )
      );
    } else if (header == "isPost") {
      setChildMenuRecords((prevData: any) =>
        prevData.map((item: any) =>
          item.menuId === id ? { ...item, isPost: !item.isPost } : item
        )
      );
    }
  };
  const numberToBoolean = (num: any) => {
    return num !== 0;
  };

  // const columns = [
  //   {
  //     field: "action",
  //     headerClassName: "MuiDataGrid-colCell",
  //     headerName: t("text.Action"),
  //     minWidth: 150,
  //     renderCell: (params: any) => (
  //       <Stack spacing={2} direction="row">
  //         <EditIcon
  //           style={{
  //             fontSize: "20px",
  //             color: "blue",
  //             cursor: "pointer",
  //           }}
  //           onClick={() => routeChangeEdit(params.row)}
  //         />

  //       </Stack>
  //     ),
  //   },

  //   {
  //     field: "name",
  //     headerName: t("text.RoleName"),
  //     flex: 1,
  //     headerClassName: "MuiDataGrid-colCell",
  //   },
  // ];

  return (
    <>
      <Card
        style={{
          width: "100%",
          // height: "100%",
          backgroundColor: "#E9FDEE",
          border: ".5px solid #FF7722 ",
          marginTop: "3vh",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            "& .MuiDataGrid-colCell": {
              backgroundColor: `var(--grid-headerBackground)`,
              color: `var(--grid-headerColor)`,
              fontSize: 17,
              fontWeight: 900,
            },
          }}
          style={{ padding: "10px" }}
        >
          <ConfirmDialog />

          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
            {t("text.UserPermissionMaster")}
          </Typography>
          <Divider />

          <Box height={10} />

          <Stack direction="row" spacing={2} classes="my-2 mb-2">

            <Button
              onClick={handleOpen}
              variant="contained"
              endIcon={<AddCircleIcon />}
              size="large"
              style={{ backgroundColor: `var(--header-background)` }}
            >
              {t("text.add")}
            </Button>

          </Stack>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <Box>
              <br />
              <div
                style={{
                  width: "100%",
                  backgroundColor: `var(--grid-background)`,
                }}
              >
                {/* <DataGrid
                  rows={records}
                  columns={columns}
                  autoHeight
                  slots={{
                    toolbar: GridToolbar,
                  }}
                  rowSpacingType="border"
                  pagination={true}
                  pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                    value: size,
                    label: `${size}`,
                  }))}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 5 } },
                  }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                    },
                  }}
                /> */}
              </div>
            </Box>
          )}
        </Paper>
      </Card>

      <Modal open={open} style={{ height: "600px" }}>
        <Box sx={style}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 10,
              top: 8,
              color: (theme) => theme.palette.grey[900],
            }}
          >
            <CloseIcon />
          </IconButton>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
              {/* <Grid md={5} item>
                <TextField
                  type="text"
                  value={formik.values.roleName}
                  label={
                    <span>
                      {t("text.enterRoleName")}{" "}
                      {requiredFields.includes("roleName") && (
                        <span
                          style={{
                            color: formik.values.roleName ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name="roleName"
                  id="roleName"
                  style={{ marginBottom: "10px" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.roleName && formik.errors.roleName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.roleName)}
                  </div>
                ) : null}
              </Grid> */}

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={empOption}
                  value={formik.values.empName}
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("empName", newValue?.label);
                    formik.setFieldValue("empid", newValue?.value);
                    // getModalListByUser(newValue?.userId)

                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.selectempname")} />}
                    />
                  )}
                />
              </Grid>



              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={<CustomLabel text={t("text.userid")} required={true} />}
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="registerModel.username"
                  id="registerModel.username"
                  value={formik.values.registerModel.username}
                  placeholder={t("text.userid")}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />

              </Grid>


              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={<CustomLabel text="Password" required={true} />}
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="registerModel.password"
                  id="registerModel.password"
                  value={formik.values.registerModel.password}
                  placeholder="Password"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.registerModel?.password && !!formik.errors.registerModel?.password}
                  helperText={
                    formik.touched.registerModel?.password && formik.errors.registerModel?.password ? (
                      <div>
                        <div style={{ color: "red", margin: "5px" }}>
                          {formik.errors.registerModel.password}
                        </div>
                        <small>
                          <ul style={{ margin: 0, padding: 0, listStyleType: "none" }}>
                            {passwordSuggestions.map((suggestion, index) => (
                              <li key={index}>- {suggestion}</li>
                            ))}
                          </ul>
                        </small>
                      </div>
                    ) : (
                      <small>
                        <ul style={{ margin: 0, padding: 0, listStyleType: "none" }}>
                          {passwordSuggestions.length > 0 && (
                            <li style={{ color: "#777" }}>Password should contain:</li>
                          )}
                          {passwordSuggestions.map((suggestion, index) => (
                            <li key={index}>- {suggestion}</li>
                          ))}
                        </ul>
                      </small>
                    )
                  }
                  type={showPassword ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                        <IconButton
                          aria-label="generate password"
                          onClick={handleGeneratePassword}
                          edge="end"
                        >
                          <span role="img" aria-label="generate">🔑</span>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>


              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={roleOption}
                  value={formik.values.registerModel.role}
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    console.log(newValue?.value);
                    formik.setFieldValue("registerModel.role", newValue?.label);
                    formik.setFieldValue("roleId", newValue?.value);
                    getModalListByRole(newValue?.value)
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.role")} />}
                    />
                  )}
                />
              </Grid>



              <Grid item lg={3} sm={3}>
                <Grid>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: `var(--header-background)`,
                      color: `var(--header-color)`,
                      marginBottom: "10px",
                      marginTop: "3px",
                    }}
                  >
                    {editID == "-1" ? t("text.save") : t("text.update")}
                  </Button>
                </Grid>
              </Grid>
              <Grid item lg={3} sm={3}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginBottom: "10px",
                    marginTop: "3px",
                  }}
                  onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    formik.resetForm();
                    setRows([]);
                    setChildMenuRecords([]);
                    setRecords([]);
                  }}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid md={12} item>
                <TableContainer sx={{ maxHeight: "65vh" }}>
                  <table
                    style={{
                      width: "100%",
                      border: "1px solid black",
                      borderCollapse: "collapse",
                    }}
                  >
                    <thead style={{ position: "sticky" }}>
                      <tr
                        style={{
                          border: "1px solid black",
                          fontSize: "2.7vh",
                          fontWeight: "500",
                          backgroundColor: `var(--header-background)`,
                          color: `var(--header-color)`,
                          textAlign: "center",
                        }}
                      >
                        <td>{t("text.MenuName")}</td>
                        <td>
                          {t("text.add")} <br />
                          <input
                            type="checkbox"
                            style={{
                              marginLeft: "10px",
                              marginRight: "10px",
                            }}
                            checked={childMenuRecords.every(
                              (item: any) => item.isAdd
                            )}
                            onChange={(e) =>
                              handleSelectAll("isAdd", e.target.checked)
                            }
                          />
                        </td>
                        <td>
                          {t("text.Edit")} <br />
                          <input
                            type="checkbox"
                            style={{
                              marginLeft: "10px",
                              marginRight: "10px",
                            }}
                            checked={childMenuRecords.every(
                              (item: any) => item.isEdit
                            )}
                            onChange={(e) =>
                              handleSelectAll("isEdit", e.target.checked)
                            }
                          />
                        </td>
                        <td>
                          {t("text.delete")} <br />
                          <input
                            type="checkbox"
                            style={{
                              marginLeft: "10px",
                              marginRight: "10px",
                            }}
                            checked={childMenuRecords.every(
                              (item: any) => item.isDel
                            )}
                            onChange={(e) =>
                              handleSelectAll("isDel", e.target.checked)
                            }
                          />
                        </td>
                        <td>
                          {t("text.View")} <br />
                          <input
                            type="checkbox"
                            style={{
                              marginLeft: "10px",
                              marginRight: "10px",
                            }}
                            checked={childMenuRecords.every(
                              (item: any) => item.isView
                            )}
                            onChange={(e) =>
                              handleSelectAll("isView", e.target.checked)
                            }
                          />
                        </td>
                        <td>
                          {t("text.Print")} <br />
                          <input
                            type="checkbox"
                            style={{
                              marginLeft: "10px",
                              marginRight: "10px",
                            }}
                            checked={childMenuRecords.every(
                              (item: any) => item.isPrint
                            )}
                            onChange={(e) =>
                              handleSelectAll("isPrint", e.target.checked)
                            }
                          />
                        </td>
                        <td>
                          {t("text.Export")} <br />
                          <input
                            type="checkbox"
                            style={{
                              marginLeft: "10px",
                              marginRight: "10px",
                            }}
                            checked={childMenuRecords.every(
                              (item: any) => item.isExport
                            )}
                            onChange={(e) =>
                              handleSelectAll("isExport", e.target.checked)
                            }
                          />
                        </td>
                        <td>
                          {t("text.Release")} <br />
                          <input
                            type="checkbox"
                            style={{
                              marginLeft: "10px",
                              marginRight: "10px",
                            }}
                            checked={childMenuRecords.every(
                              (item: any) => item.isRelease
                            )}
                            onChange={(e) =>
                              handleSelectAll("isRelease", e.target.checked)
                            }
                          />
                        </td>
                        <td>
                          {t("text.Post")} <br />
                          <input
                            type="checkbox"
                            style={{
                              marginLeft: "10px",
                              marginRight: "10px",
                            }}
                            checked={childMenuRecords.every(
                              (item: any) => item.isPost
                            )}
                            onChange={(e) =>
                              handleSelectAll("isPost", e.target.checked)
                            }
                          />
                        </td>
                      </tr>
                    </thead>
                    <tbody style={{ color: "#000000" }}>
                      {childMenuRecords.map(
                        (rows: any, key: string | number) => {
                          console.log(childMenuRecords);
                          return (
                            <>
                              {
                                <tr
                                  style={{
                                    border: "1px solid black",
                                    fontSize: "2.7vh",

                                  }}
                                >

                                  <td style={{ padding: "10px" }}>
                                    {rows.menuName}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      type="checkbox"
                                      onChange={() =>
                                        handleCheckboxChange(
                                          rows.menuId,
                                          "isAdd"
                                        )
                                      }

                                      checked={
                                        childMenuRecords[key]["isAdd"]
                                          ? true
                                          : false
                                      }
                                      name="isAdd"
                                      className="isAdd"
                                    />
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      type="checkbox"
                                      onChange={() =>
                                        handleCheckboxChange(
                                          rows.menuId,
                                          "isEdit"
                                        )
                                      }
                                      checked={
                                        childMenuRecords[key]["isEdit"]
                                          ? true
                                          : false
                                      }
                                      name="isEdit"
                                      className="isEdit"
                                    />
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      type="checkbox"
                                      onChange={() =>
                                        handleCheckboxChange(
                                          rows.menuId,
                                          "isDel"
                                        )
                                      }
                                      checked={
                                        childMenuRecords[key]["isDel"]
                                          ? true
                                          : false
                                      }
                                      name="isDel"
                                      className="isDel"
                                    />
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      type="checkbox"
                                      onChange={() =>
                                        handleCheckboxChange(
                                          rows.menuId,
                                          "isView"
                                        )
                                      }
                                      checked={
                                        childMenuRecords[key]["isView"]
                                          ? true
                                          : false
                                      }
                                      name="isView"
                                      className="isView"
                                    />
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      type="checkbox"
                                      onChange={() =>
                                        handleCheckboxChange(
                                          rows.menuId,
                                          "isPrint"
                                        )
                                      }
                                      checked={
                                        childMenuRecords[key]["isPrint"]
                                          ? true
                                          : false
                                      }
                                      name="isPrint"
                                      className="isPrint"
                                    />
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      type="checkbox"
                                      onChange={() =>
                                        handleCheckboxChange(
                                          rows.menuId,
                                          "isExport"
                                        )
                                      }
                                      checked={
                                        childMenuRecords[key]["isExport"]
                                          ? true
                                          : false
                                      }
                                      name="isExport"
                                      className="isExport"
                                    />
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      type="checkbox"
                                      onChange={() =>
                                        handleCheckboxChange(
                                          rows.menuId,
                                          "isRelease"
                                        )
                                      }
                                      checked={
                                        childMenuRecords[key]["isRelease"]
                                          ? true
                                          : false
                                      }
                                      name="isRelease"
                                      className="isRelease"
                                    />
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      type="checkbox"
                                      onChange={() =>
                                        handleCheckboxChange(
                                          rows.menuId,
                                          "isPost"
                                        )
                                      }
                                      checked={
                                        childMenuRecords[key]["isPost"]
                                          ? true
                                          : false
                                      }
                                      name="isPost"
                                      className="isPost"
                                    />
                                  </td>
                                </tr>
                              }
                            </>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                </TableContainer>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>

      <ToastApp />
    </>
  );
}
